import { DecimalPipe, NgClass } from "@angular/common";
import { Component, Inject, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { CoreService } from "../../../../../../../../shared/src/lib/services/core.service";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { PnlCalculatorService } from "../../../../../../../../shared/src/lib/services/pnl-calculator.service";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-line-market-pnl",
  imports: [DecimalPipe, NgClass, MatProgressSpinnerModule, MatDialogClose, MatDialogContent, MatIcon],
  templateUrl: "./line-market-pnl.component.html",
  styleUrl: "./line-market-pnl.component.scss",
})
export class LineMarketPnlComponent implements OnDestroy, OnInit {
  @Input() market: any;
  @Input() type: "fancy" | "normal" = "normal";
  readonly destroy$ = new Subject<void>();
  pnlCalculator = inject(PnlCalculatorService);
  coreService = inject(CoreService);
  runPnLs: { runs: number; pnl: number }[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { type: "fancy" | "normal"; marketId: string },
  ) {}

  ngOnInit() {
    this.getLinePnl();
  }

  getLinePnl() {
    this.pnlCalculator
      .getLadderTable(this.data?.marketId, this.data?.type)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: any) => {
        // console.log(result);
        this.runPnLs = result;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
